import React from 'react';

import {useMediaGallerySettingsDisplay} from '../../hooks';
import {AxisDropdown} from '../common/AxisDropdown';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';

export const ColumnContent = () => {
  const {updateConfig, settingsLevel, panelRef} = useMediaSettingsContext();
  const gallerySettings = useMediaGallerySettingsDisplay(
    settingsLevel,
    panelRef
  );
  return (
    <AxisDropdown
      configField="gallerySettings"
      initialValue={gallerySettings.axis}
      onSelectOption={option => updateConfig({gallerySettings: {axis: option}})}
      title="Column content"
    />
  );
};
